import React from 'react';
import { connect } from 'react-redux';

import { FormattedMessage } from 'react-intl';
import { isShippingFree } from '../../reducers/prices';
import { getPageTitle } from '../../reducers/title';
import { getDrawerState } from '../../reducers/ui.header';
import Heading from '../heading/Heading';
import EuShippingPaused from './EuShippingPaused';

const ShippingCostOverview = ({ isShippingFree, showEuImage }) => (
    <React.Fragment>
        <Heading
            level={4} text={<FormattedMessage
                id='GERMANY'
                description='Label for the germany'
                defaultMessage='Deutschland'
            />}
        />
        <p>
            {
            isShippingFree ?
                <FormattedMessage
                    id='SHIPPING_COST_GERMANY_FREE'
                    description='Label for the german shipping cost free.'
                    defaultMessage='versandkostenfrei innerhalb Deutschlands'
                />
            :
                <FormattedMessage
                    id='SHIPPING_COST_GERMANY_BELOW'
                    description='Label for the german shipping cost below 125€.'
                    defaultMessage='unter 125€ - 5,95€'
                />
        }
        </p>
        <p>
            {
                isShippingFree ?
                    null
                    :
                    <FormattedMessage
                        id='SHIPPING_COST_GERMANY_ABOVE'
                        description='Label for the german shipping cost above 125€.'
                        defaultMessage='über 125€ - versandkostenfrei'
                    />
            }
        </p>
        <EuShippingPaused headingLevel={4} showImage={showEuImage} />
        <Heading
            level={4} text={<FormattedMessage
                id='SHIPPING_WORLD'
                description='Label for the rest of the world shipping cost.'
                defaultMessage='Versand in Drittstaaten (Nicht EU)'
            />}
        />
        <p>
            <FormattedMessage
                id='SHIPPING_COST_WORLD'
                description='Text for the rest of the world shipping cost.'
                defaultMessage='10€ + 10% vom Bestellwert'
            />
        </p>
    </React.Fragment>
        );

const makeMapStateToProps = initialState => {
    const shippingFree = isShippingFree(initialState);
    return state => (
        {
            isShippingFree: shippingFree,
        }
    );
};

export default connect(makeMapStateToProps)(ShippingCostOverview);



// WEBPACK FOOTER //
// ./src/components/common/ShippingCostOverview.js